import clsx from 'clsx'
import { useEffect, useRef, useState } from 'react'

export interface StickyOnScrollProps {
  className?: string
  render?: (isSticky: boolean) => React.ReactNode
  rootMargin?: string // Accepts any valid CSS margin value
}

const StickyOnScroll: React.FC<StickyOnScrollProps> = ({
  className,
  render,
  rootMargin = '-100px',
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const [isSticky, setSticky] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => setSticky(!entry.isIntersecting), {
      threshold: 0,
      rootMargin: rootMargin,
    })
    const currentRef = ref.current

    if (currentRef) {
      observer.observe(currentRef)
    }

    return () => {
      observer.disconnect()
    }
  }, [rootMargin])

  const stickyClass = clsx('sticky top-0', className)
  const combinedClassName = `transition-all ${isSticky ? stickyClass : 'relative'}`

  return (
    <>
      <div ref={ref} />
      <div className={combinedClassName}>{render ? render(isSticky) : null}</div>
    </>
  )
}
export default StickyOnScroll
